import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { withTranslation } from 'react-i18next';
import SelectedItemsPanel from '../SelectedItemsPanel';
import GroupOperationButton from '../GroupOperationButton';
import GallectionListMenu from '../GallectionListMenu';
import { getFolderIdsDisabledForDeviationCopy } from '../../helpers';
import { copyDeviations, moveDeviations, removeDeviations } from '../../actions';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import withGallections from '../../_hocs/withGallections';
import { useManageDeviations } from '../../_hocs/withManageDeviations';
import LabelAsMenu from '../LabelAsMenu';
import manageableSelectedItemsPanelStyles from './ManageableSelectedItemsPanel.scss';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
const enhance = compose(withGallections, withCurrentGallection, withCurrentSubfolder, withSelectedDeviations, connectMediaStore(null, {
    copyDeviations,
    moveDeviations,
    removeDeviations
}), withTranslation());
export const ManageableSelectedItemsPanel = ({ t , gallections , currentGallection: currentTopLevelGallection , currentSubfolder , selectedDeviations , selectedDeviationIds  })=>{
    var _ref;
    const { isCopyToSupportedGlobally , isMoveToSupportedGlobally , isCopyToSupportedInThisFolder , isMoveToSupportedInThisFolder , isRemoveSupportedInThisFolder , isLabelAsSupportedInThisFolder , moveTo , copyTo , remove  } = useManageDeviations(selectedDeviations);
    const showCopyTo = isCopyToSupportedGlobally;
    const showMoveTo = isMoveToSupportedGlobally;
    const showLabelAs = isLabelAsSupportedInThisFolder;
    const isCopyToDisabled = !isCopyToSupportedInThisFolder;
    const isMoveToDisabled = !isMoveToSupportedInThisFolder;
    const isRemoveDisabled = !isRemoveSupportedInThisFolder;
    const currentFolderId = (_ref = currentSubfolder || currentTopLevelGallection) === null || _ref === void 0 ? void 0 : _ref.folderId;
    return /*#__PURE__*/ React.createElement(SelectedItemsPanel, {
        extras: /*#__PURE__*/ React.createElement("div", null, showMoveTo && /*#__PURE__*/ React.createElement(GroupOperationButton, {
            className: manageableSelectedItemsPanelStyles['group-operation-button'],
            disabled: isMoveToDisabled
        }, t('mediapopup.moveTo'), /*#__PURE__*/ React.createElement("div", {
            className: manageableSelectedItemsPanelStyles['group-operation-menu-wrapper']
        }, /*#__PURE__*/ React.createElement(GallectionListMenu, {
            onSelect: moveTo
        }))), showCopyTo && /*#__PURE__*/ React.createElement(GroupOperationButton, {
            className: manageableSelectedItemsPanelStyles['group-operation-button'],
            disabled: isCopyToDisabled
        }, t('mediapopup.copyTo'), /*#__PURE__*/ React.createElement("div", {
            className: manageableSelectedItemsPanelStyles['group-operation-menu-wrapper']
        }, /*#__PURE__*/ React.createElement(GallectionListMenu, {
            disableFolderIds: getFolderIdsDisabledForDeviationCopy(gallections, currentTopLevelGallection === null || currentTopLevelGallection === void 0 ? void 0 : currentTopLevelGallection.folderId),
            onSelect: copyTo
        }))), showLabelAs && /*#__PURE__*/ React.createElement(GroupOperationButton, {
            className: manageableSelectedItemsPanelStyles['group-operation-button']
        }, t('mediapopup.labelAs'), /*#__PURE__*/ React.createElement("div", {
            className: manageableSelectedItemsPanelStyles['group-operation-menu-wrapper']
        }, /*#__PURE__*/ React.createElement(LabelAsMenu, {
            folderId: currentFolderId,
            deviationIds: selectedDeviationIds
        }))), /*#__PURE__*/ React.createElement(GroupOperationButton, {
            onClick: remove,
            className: classnames(manageableSelectedItemsPanelStyles['group-operation-button'], manageableSelectedItemsPanelStyles['group-remove']),
            disabled: isRemoveDisabled
        }, t('mediapopup.delete')))
    });
};
ManageableSelectedItemsPanel.displayName = 'ManageableSelectedItemsPanel';
export default enhance(ManageableSelectedItemsPanel);
